import {
  MAINNET_GRAPH_NODE_BASE_URL,
  TESTNET_GRAPH_NODE_BASE_URL,
  GRAPH_NODE_EXCHANGE_SUBGRAPH_URL,
  MAINNET_GRAPH_NODE_EXCHANGE_SUBGRAPH_URL,
  TESTNET_GRAPH_NODE_EXCHANGE_SUBGRAPH_URL,
  MAINNET_GRAPH_NODE_EXCHANGE_V2_SUBGRAPH_URL,
  TESTNET_GRAPH_NODE_EXCHANGE_V2_SUBGRAPH_URL,
} from '@pancakeswap/address-config'
import { ChainId } from '@pancakeswap/sdk'
import { GraphNodeBaseUrl } from 'config/launchpad'

export const GRAPH_API_PROFILE = 'https://api.thegraph.com/subgraphs/name/magmaswap/profile'
export const GRAPH_API_PREDICTION_BNB = 'https://api.thegraph.com/subgraphs/name/magmaswap/prediction-v2'
export const GRAPH_API_PREDICTION_CAKE = 'https://api.thegraph.com/subgraphs/name/magmaswap/prediction-cake'

export const GRAPH_API_LOTTERY = 'https://api.thegraph.com/subgraphs/name/magmaswap/lottery'
export const SNAPSHOT_BASE_URL = process.env.NEXT_PUBLIC_SNAPSHOT_BASE_URL

// console.log('process.env.NEXT_PUBLIC_ENV', process.env.NEXT_PUBLIC_ENV)
export const API_PROFILE = 'https://profile.pancakeswap.com'
export const API_NFT = 'https://nft.pancakeswap.com/api/v1'
export const SNAPSHOT_API = `${SNAPSHOT_BASE_URL}/graphql`
export const SNAPSHOT_HUB_API = `${SNAPSHOT_BASE_URL}/api/message`
export const GRAPH_API_POTTERY = 'https://api.thegraph.com/subgraphs/name/magmaswap/pottery'

/**
 * V1 will be deprecated but is still used to claim old rounds
 */
export const GRAPH_API_PREDICTION_V1 = 'https://api.thegraph.com/subgraphs/name/magmaswap/prediction'

export const INFO_CLIENT = GRAPH_NODE_EXCHANGE_SUBGRAPH_URL
export const V3_BSC_INFO_CLIENT = GRAPH_NODE_EXCHANGE_SUBGRAPH_URL

export const INFO_CLIENT_ETH = 'https://api.thegraph.com/subgraphs/name/magmaswap/exhange-eth'
export const BLOCKS_CLIENT = `${GraphNodeBaseUrl}/agni/blocks`
// export const BLOCKS_CLIENT_ETH = 'https://api.thegraph.com/subgraphs/name/blocklytics/ethereum-blocks'
export const STABLESWAP_SUBGRAPH_CLIENT = 'https://api.thegraph.com/subgraphs/name/magmaswap/exchange-stableswap'
export const GRAPH_API_NFTMARKET = 'https://api.thegraph.com/subgraphs/name/magmaswap/nft-market'
export const GRAPH_HEALTH = 'https://api.thegraph.com/index-node/graphql'

export const TC_MOBOX_SUBGRAPH = 'https://api.thegraph.com/subgraphs/name/magmaswap/trading-competition-v3'
export const TC_MOD_SUBGRAPH = 'https://api.thegraph.com/subgraphs/name/magmaswap/trading-competition-v4'

export const BIT_QUERY = 'https://graphql.bitquery.io'

export const ACCESS_RISK_API = '/api/risk'

export const CELER_API = 'https://api.celerscan.com/scan'

export const INFO_CLIENT_WITH_CHAIN = {
  [ChainId.MANTLE]: `${MAINNET_GRAPH_NODE_EXCHANGE_V2_SUBGRAPH_URL}`,
  [ChainId.MANTLE_TESTNET]: `${TESTNET_GRAPH_NODE_EXCHANGE_V2_SUBGRAPH_URL}`,
}

export const BLOCKS_CLIENT_WITH_CHAIN = {
  [ChainId.MANTLE]: `${MAINNET_GRAPH_NODE_BASE_URL}/agni/blocks`,
  [ChainId.MANTLE_TESTNET]: `${TESTNET_GRAPH_NODE_BASE_URL}/agni/blocks`,
}

export const ASSET_CDN = '/'

export const V3_SUBGRAPH_URLS = {
  [ChainId.MANTLE]: `${MAINNET_GRAPH_NODE_EXCHANGE_SUBGRAPH_URL}`,
  [ChainId.MANTLE_TESTNET]: `${TESTNET_GRAPH_NODE_EXCHANGE_SUBGRAPH_URL}`,
} satisfies Record<ChainId, string>
export const V2_SUBGRAPH_URLS = {
  [ChainId.MANTLE]: `${MAINNET_GRAPH_NODE_EXCHANGE_V2_SUBGRAPH_URL}`,
  [ChainId.MANTLE_TESTNET]: `${TESTNET_GRAPH_NODE_EXCHANGE_V2_SUBGRAPH_URL}`,
} satisfies Record<ChainId, string>

export const TRADING_REWARD_API = 'https://pancake-trading-fee-rebate-api.pancake.run/api/v1'

export const QUOTING_API = `${process.env.NEXT_PUBLIC_QUOTING_API}/v0/quote`

export const FARMS_API = 'https://farms-api.pancakeswap.com'
